"use client";

import { Close } from "@mui/icons-material";
import { Directions } from "@mui/icons-material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Input, InputIcon, Text, TextColor, TextSize, TextVariant, TextWeight } from "../../components";
import { AvailableIcon, ShopIcon, UnavailableIcon } from "../../components/Svg/icons";
const ShopAvailabilityDrawer = ({
  combinations,
  attributes,
  selectedColor,
  selectedSize,
  searchedAvailability,
  searchedShops,
  selectedReference,
  closeDrawer,
  searchAvailabilityFunc,
  clearSearch,
  selectColor,
  selectSize
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const uniqueByAttribute = attributes_0 => {
    const seen = new Set();
    return attributes_0.filter(attribute => {
      const key = attribute.idAttribute;
      if (!seen.has(key)) {
        seen.add(key);
        return true;
      }
      return false;
    });
  };
  const colors_0 = useMemo(() => {
    const colors = uniqueByAttribute(attributes.filter(attr => attr.groupName === "Kolor"));
    if (!Array.isArray(combinations)) return [];
    colors.forEach((color, index) => {
      const imageUrl = combinations.filter(record => Object.values(record.attributes).some(value => typeof value === "string" && value.includes(color.attributeName)));
      if (colors[index]) {
        colors[index].imageUrl = imageUrl[0]?.imageUrl;
      }
    });
    if (colors.length === 1) {
      selectColor(colors[0] || null);
    }
    return colors;
  }, [attributes]);
  const sizes = uniqueByAttribute(attributes.filter(attr_0 => attr_0.groupName.includes("Rozmiar")));
  useEffect(() => {
    if (searchQuery.length > 3 && selectedReference) {
      searchAvailabilityFunc(searchQuery, selectedReference);
    } else {
      clearSearch();
    }
  }, [searchQuery, selectedSize, selectedColor, selectedReference]);
  const infoContent = !selectedColor ? "Wybierz kolor aby przejść dalej" : !selectedSize ? "Wybierz rozmiar by wyświetlić listę sklepów" : searchQuery.length <= 3 ? "Podaj miejscowość by wyświetlić listę sklepów" : null;
  const interactionRef = useRef(null);
  return <div className="w-screen md:w-auto md:min-w-[600px] relative px-8 pt-[70px] h-full overflow-hidden">
      <div className="h-auto" ref={interactionRef}>
        {/* Header */}
        <div className="flex gap-2 w-full justify-between">
          <Text text="Sprawdź dostępność w sklepach stacjonarnych" variant={TextVariant.H6} weight={TextWeight.BOLD} className="mb-4" />
          <div onClick={() => {
          closeDrawer();
          clearSearch();
          selectColor(null);
          selectSize(null);
          setSearchQuery("");
        }} className="cursor-pointer">
            <Close className="w-5 h-5" />
          </div>
        </div>

        {/* COLORS */}
        {colors_0.length !== 1 && <div className="flex flex-col items-start mb-4">
            <Text text="Wybierz kolor:" fontSize={TextSize.S} weight={TextWeight.BOLD} color={TextColor.GRAYSCALE_600} className="mb-2" />

            <div className="flex flex-wrap gap-4">
              {colors_0.map(color_0 => <div onClick={() => {
            selectColor(color_0);
            selectSize(selectedSize);
          }} key={color_0.idAttribute} className={`cursor-pointer text-base font-extrabold leading-[21.82px] ${selectedColor?.idAttribute === color_0.idAttribute ? "border-b-2 border-black -mb-0.5" : ""}`}>
                  {color_0.attributeName}
                </div>)}
            </div>
          </div>}

        {/* SIZES */}
        {selectedColor && <div className="flex flex-col items-start mb-4">
            <Text text="Wybierz rozmiar:" fontSize={TextSize.S} weight={TextWeight.BOLD} color={TextColor.GRAYSCALE_600} className="mb-2" />
            <div className="flex flex-wrap gap-4">
              {sizes.map(size => <div onClick={() => selectSize(size)} key={size.idAttribute} className={`cursor-pointer text-base font-['NunitoSans-ExtraBold'] font-extrabold leading-[21.82px] hover:border-b-2 hover:border-black hover:-mb-0.5 ${selectedSize?.idAttribute === size.idAttribute ? "border-b-2 border-black -mb-0.5" : ""}`}>
                  {size.attributeName}
                </div>)}
            </div>
          </div>}

        {/* FORM */}
        {selectedColor && selectedSize && <div className="mt-8 mb-2 w-full">
            <Input id="shop-availability-input" name="shop-availability-input" icon iconPosition="left" iconBackground={true} iconGreyColored={true} iconVariant={InputIcon.SEARCH} placeholder="Miejscowość" onChange={e => setSearchQuery(e.target.value)} autoComplete="off" />
          </div>}

        {/* SEARCH INFO */}
        {searchedShops.length > 0 && <div className="flex flex-row items-center gap-2">
            <ShopIcon color={TextColor.ERROR_500} className="w-4 h-4" />
            <Text text="Informacja o dostępności w naszych sklepach ma charakter orientacyjny." color={TextColor.ERROR_500} fontSize={TextSize.S} />
          </div>}
      </div>

      <div className="flex flex-col h-full py-5" style={{
      height: interactionRef.current?.offsetHeight ? `calc(100% - ${interactionRef.current.offsetHeight}px)` : "100%",
      maxHeight: interactionRef.current?.offsetHeight ? `calc(100% - ${interactionRef.current.offsetHeight}px)` : "100%"
    }}>
        {infoContent && <Text text={infoContent} color={TextColor.GRAYSCALE_400} fontSize={TextSize.S} className="h-full flex justify-center items-center text-center" />}

        {searchedShops.map(shop => {
        const availability = searchedAvailability.find(record_0 => record_0.symbol === shop.symbol && Number(record_0.quantity) > 0);
        return <div key={shop.symbol} className="flex flex-col">
              <div className="flex flex-row items-center justify-between">
                <Text text={shop.adres} fontSize={TextSize.S} weight={TextWeight.BOLD} className="mb-2 cursor-pointer" onClick={() => {
              window.open(`https://www.google.com/maps/dir/?api=1&destination=${shop.lat},${shop.lng}`, "_blank");
            }} />
                <Directions onClick={e_0 => {
              e_0.stopPropagation(); // Zapobiega wywołaniu handleMarkerClick
              window.open(`https://www.google.com/maps/dir/?api=1&destination=${shop.lat},${shop.lng}`, "_blank");
            }} className="cursor-pointer hover:text-gray-500 transition-colors" />
              </div>

              <Text text={`${shop.kodPocztowy} ${shop.miasto}`} color={TextColor.GRAYSCALE_600} fontSize={TextSize.S} className="mb-2" />

              <div className="flex flex-row items-center gap-2 mb-8">
                {availability ? <>
                    <AvailableIcon className="w-4 h-4" color={TextColor.SPECIAL_500} />
                    <Text text="dostępne" color={TextColor.SPECIAL_500} fontSize={TextSize.S} weight={TextWeight.BOLD} />
                  </> : <>
                    <UnavailableIcon className="w-4 h-4" color={TextColor.ERROR_500} />
                    <Text text="niedostępne" color={TextColor.ERROR_500} fontSize={TextSize.S} weight={TextWeight.BOLD} />
                  </>}
              </div>
            </div>;
      })}
      </div>
    </div>;
};
export default ShopAvailabilityDrawer;